import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { browserLocalPersistence, setPersistence } from 'firebase/auth';
import { config, validateConfig } from '../config/environment';

// Validate configuration on import
if (!validateConfig()) {
  throw new Error('Invalid Firebase configuration. Please check your environment variables.');
}

let app: any = null;
let auth: any = null;
let db: any = null;

export const getFirebaseApp = () => {
  if (!app) {
    console.log('Initializing Firebase with config:', {
      projectId: config.firebase.projectId,
      appId: config.firebase.appId?.substring(0, 10) + '...'
    });
    app = initializeApp(config.firebase);
    console.log('Firebase app initialized:', app);
  }
  return app;
};

export const getFirebaseAuth = () => {
  if (!auth) {
    auth = getAuth(getFirebaseApp());
    // Configurer la persistance locale
    setPersistence(auth, browserLocalPersistence)
      .then(() => {
        console.log("Firebase auth persistence set to LOCAL (shared)");
      })
      .catch((error) => {
        console.error("Error setting auth persistence (shared):", error);
      });
  }
  return auth;
};

export const getFirebaseDB = () => {
  if (!db) {
    db = getFirestore(getFirebaseApp());
  }
  return db;
};
